import { createFileRoute, redirect } from "@tanstack/react-router";
import { anunturiTarget } from "@/pages/legacy/AnunturiRedirect";

// Legacy address: server-side 301 to /vehicles with filters remapped.
export const Route = createFileRoute("/anunturi/")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: anunturiTarget(location.searchStr ?? ""), statusCode: 301 });
  },
});
